import { Box, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { t } from 'i18next';
import BetGameScoreInfo from '../../../features/bets/BetGameScoreInfo';
import Bet from '../../../features/bets/types/Bet';
import { getFullBetTitle } from '../../utils/stringTransform';
import TeamAvatar from '../avatar/TeamAvatar';
import CustomButton from '../btn/CustomButton';
import CustomCancelButton from '../btn/CustomCancelButton';

interface DialogProps {
	open: boolean;
	onClose: () => void;
	onSave: () => void;
	gameScoreInput: string | undefined;
	bet?: Bet;
	buttonColor?: 'success' | 'error' | 'warning' | 'info' | 'primary' | 'secondary';
	buttonText: string;
	sx?: {};
}

export default function CustomBetCheckDialog({
	open,
	onClose,
	onSave,
	gameScoreInput,
	bet,
	buttonColor = 'primary',
	buttonText,
	sx,
}: DialogProps): JSX.Element {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogContent>
				<Box sx={{ fontWeight: '600', fontSize: '1rem' }}>
					<BetGameScoreInfo gameScoreInput={gameScoreInput} />
				</Box>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<b>{t('homeTeam')}:</b>
					<TeamAvatar team={bet?.homeTeam} />
				</Box>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<b>{t('awayTeam')}:</b>
					<TeamAvatar team={bet?.awayTeam} />
				</Box>
				<Typography>
					<b>{t('bet')}:</b> {getFullBetTitle(bet?.betTitle)}
				</Typography>
			</DialogContent>
			<DialogActions>
				<CustomCancelButton onClick={onClose} buttonVariant="outlined" />
				<CustomButton
					sx={{ height: '2rem', ...sx }}
					onClick={onSave}
					buttonText={buttonText}
					buttonColor={buttonColor}
					autoFocus
				/>
			</DialogActions>
		</Dialog>
	);
}
